import React from 'react';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header/Header';

export default function TermsConditions() {
  return (
    <div className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="page-content" className="mb-0">
            <div className="container mt-5 mb-5" style={{ minHeight: '50vh' }}>
              <h1 className="text-center mb-4">TERMS & CONDITIONS</h1>
              <div className="policy-content" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li className="mb-3"><strong>Strict No-Credit Policy:</strong> All rental charges, security deposits, and booking fees must be paid in advance. No credit or post-payment services are offered under any circumstances.</li>
                  <li className="mb-3"><strong>Identity Verification:</strong> The customer must present valid original identity proofs (Original Driving License, Passport, etc., along with a secondary ID) at the time of equipment pickup.</li>
                  <li className="mb-3"><strong>Website Orders:</strong> To maintain transparency and systematic tracking, all orders and bookings must be placed officially through our website (<strong>www.adcaster.in</strong>).</li>
                  <li className="mb-3"><strong>Equipment Handling & Responsibility:</strong> The renter assumes full responsibility for the equipment from the time of pickup to its return. Equipment must be returned in the exact working condition as received.</li>
                  <li className="mb-3"><strong>Damage & Loss:</strong> If the equipment is damaged, lost, or stolen during the rental period, the renter is liable to pay the full cost of repair or total replacement value as determined by Adcaster.</li>
                  <li className="mb-3"><strong>Rental Period & Late Fees:</strong> Equipment must be returned strictly on or before the agreed date and time. Late returns will attract hourly or daily penalty charges.</li>
                </ul>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
